import React from 'react'
import { referralVariants } from '@web/modules/core'
import { formatText, isReferral } from '@repo/core'
import { ComponentMessageVO } from '@repo/types'

interface ReferralBodyProps {
  message: ComponentMessageVO
}

const { body } = referralVariants()

const ReferralBody = ({ message }: ReferralBodyProps) => {
  const { header, footer, sourceUrl, sourceType } = message

  return (
    <>
      {isReferral(sourceType) ? (
        <>
          <div
            className={body()}
            onClick={() => sourceUrl && window.open(sourceUrl, '_blank')}
          >
            <>
              {header ? <p>{formatText(header, 100)}</p> : <></>}
              <>
                <p>{footer ? formatText(footer, 300) : <></>}</p>
                <p>{sourceUrl}</p>
              </>
              <p>{footer}</p>
            </>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default ReferralBody
